import { TabButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { useQueryParams } from '../../../../../../hooks/useQueryParams'
import { EmberEventFn } from '../../../../../../types/emberEventFn'
import { ReconcileStatus } from '../../../../enums/reconcileStatus'

interface ReconcileStatusToggleProps {
  onChange: EmberEventFn
}

export const ReconcileStatusToggle = ({ onChange }: ReconcileStatusToggleProps): ReactElement => {
  const { track } = useSegment()
  const [queryParams, setQueryParams] = useQueryParams({
    defaultQuery: { status: ReconcileStatus.Unreconciled },
  })

  const { t } = useTranslation()

  const handleStatusChange = useCallback(
    (value: ReconcileStatus) => () => {
      onChange({ detail: { status: value } })
      setQueryParams({ status: value })

      if (value === ReconcileStatus.Reconciled) {
        track('XXX - Reconciled Entries Viewed (Client)')
      }
    },
    [onChange, setQueryParams, track],
  )

  const isUnreconciledActive = queryParams.status === ReconcileStatus.Unreconciled
  const isReconciledActive = queryParams.status === ReconcileStatus.Reconciled

  return (
    <TabButtonsGroup>
      <TabButtonsGroup.Button
        key={ReconcileStatus.Unreconciled}
        selected={isUnreconciledActive}
        onClick={handleStatusChange(ReconcileStatus.Unreconciled)}
      >
        {t('bankreconciliation.to_reconcile_transactions')}
      </TabButtonsGroup.Button>
      <TabButtonsGroup.Button
        key={ReconcileStatus.Reconciled}
        selected={isReconciledActive}
        onClick={handleStatusChange(ReconcileStatus.Reconciled)}
      >
        {t('bankreconciliation.reconciled_transactions')}
      </TabButtonsGroup.Button>
    </TabButtonsGroup>
  )
}
